import React from 'react';
import {Spin} from 'antd';
import styles from './index.module.scss';
import classNames from 'classnames';

interface ModalSpinProps {
    className?: string;
    style?: React.CSSProperties;
}

export default function ModalSpin({className, style}: ModalSpinProps) {
    return (
        <div className={classNames(styles.root, className)} style={style}>
            <Spin />
        </div>
    );
}
